module.exports = __webpack_public_path__ + "static/media/thunderstorm-sun.35fe2b63.svg";